function check_strength_unit(value){
  if(!value.match(/^[0-9]*\.?[0-9]*?$/)) {
    return value.substring(0, value.length-1);
  }
  return value;
}

// Initializes field autocompletion. Unless specified otherwise,
// autocompletion will be provided by querying the URL defined
// in the element's "data-service-url" attribute.
function init_autocomplete() {
  $('.assessment_name_substance').autocomplete({});
  $('.excipient-autocomplete').autocomplete({});
  $('.ingredient-autocomplete').autocomplete({});
  $('.therapeutic-autocomplete').autocomplete({});

  if ($('#id_reporting_name').is('[readonly]')) {
    $('#id_reporting_name').attr('autocomplete', 'off');
  } else {
    $('#id_reporting_name').autocomplete({});
  }

  $('.unit-autocomplete:not([readonly])').autocomplete({
    autoSelectFirst: true,
    minChars: 0,
  });

  $('#id_product_strength_unit').autocomplete({
    minChars: 0,
  });

  $('.quick-search-input').autocomplete({
    groupBy: 'category',
    delimiter: ';',
    onSelect: function (suggestion) {
      console.log('You selected: ' + suggestion.value + ', ' + suggestion.data);
    }
  });
}

function init_select2 () {
    let $select2 = $('.django-select2');
    $select2.djangoSelect2();
  }

function init_formsets() {
  $('.batch_list-formset').formset({
    prefix: 'batch_list',
    formCssClass: 'batch_list-formset',
    addText: 'Add batch',
    deleteText: 'remove',
    deleteTitle: 'Delete batch',
    minForms: 1,
    added: function () {
      $('.expiry_date_mask').mask('99/99/9999', {});
    }
  });

  $('.active-ingredient-identified-formset').formset({
    prefix: 'active_ingredients_identified',
    formCssClass: 'active-ingredient-identified-formset',
    addText: 'Add ingredient',
    deleteText: 'remove',
    deleteTitle: 'Delete ingredient',
    minForms: 1,
    added: function() {
      $('.ingredient-autocomplete').autocomplete({});
      $('.unit-autocomplete').autocomplete({
        autoSelectFirst: true,
        minChars: 0,
      });
    }
  });

  $('.active-ingredient-labelled-formset').formset({
    prefix: 'active_ingredients_labelled',
    formCssClass: 'active-ingredient-labelled-formset',
    addText: 'Add ingredient',
    deleteText: 'remove',
    deleteTitle: 'Remove ingredient',
    minForms: 1,
    added: function() {
      $('.ingredient-autocomplete').autocomplete({});
      $('.unit-autocomplete').autocomplete({
        autoSelectFirst: true,
        minChars: 0,
      });
    }
  });

  $('.excipient-formset').formset({
    prefix: 'excipients',
    formCssClass: 'excipient-formset',
    addText: 'Add excipient',
    deleteText: 'remove',
    deleteTitle: 'Remove excipient',
    minForms: 1,
    added: function() {
      $('.excipient-autocomplete').autocomplete({});
    }
  });

  $('.product-packaging-formset').formset({
    prefix: 'product_packaging',
    formCssClass: 'product-packaging-formset',
    addText: 'Add packaging type',
    deleteText: 'remove',
    deleteTitle: 'Remove packaging type',
    minForms: 1,
    added: function(row) {
      row.find('.django-select2').val('');
      row.find('.django-select2').djangoSelect2();
    }
  });


  $('.entry-contact-formset').formset({
    prefix: 'contact',
    formCssClass: 'entry-contact-formset',
    addText: 'Add contact',
    deleteText: 'remove',
    deleteTitle: 'Remove contact',
    minForms: 0,
    added: function() {
      $('.name_contact-autocomplete').autocomplete({});
    }
  });

  $('.therapeutic-labelled-formset').formset({
    prefix: 'therapeutic_class_labelled',
    formCssClass: 'therapeutic-labelled-formset',
    addText: 'Add therapeutic class',
    deleteText: 'remove',
    deleteTitle: 'Remove therapeutic class',
    minForms: 1,
    added: function(row) {
      row.find('.django-select2').val('');
      row.find('.django-select2').djangoSelect2();
    }
  });

  $('.therapeutic-identified-formset').formset({
    prefix: 'therapeutic_class_identified',
    formCssClass: 'therapeutic-identified-formset',
    addText: 'Add therapeutic class',
    deleteText: 'remove',
    deleteTitle: 'Remove therapeutic class',
    minForms: 1,
    added: function(row) {
      row.find('.django-select2').val('');
      row.find('.django-select2').djangoSelect2();
    }
  });

  $('.assessment-product-description-formset').formset({
    prefix: 'assessment_product_description',
    formCssClass: 'assessment-product-description',
    addText: 'Add product description',
    deleteText: 'remove',
    deleteTitle: 'Remove product description',
    minForms: 1,
    added: function(row) {
      row.find('.django-select2').val('');
      row.find('.django-select2').djangoSelect2();
    }
  });

  $('.mass-information-additional-formset').formset({
    prefix: 'mass_information_additional',
    formCssClass: 'mass-information-additional-formset',
    addText: 'Additional information',
    deleteText: 'remove',
    deleteTitle: 'Remove additional information',
    minForms: 1,
    added: function(row) {
      $('.ingredient-autocomplete').autocomplete({});
      row.find('.django-select2').val('');
      row.find('.django-select2').djangoSelect2();
    }
  });
}

function init_date_masks() {
  $('#id_assessment_cas_number').mask('000-000-000', {
    placeholder: 'nnn-nnn-nnn'
  });
  $('.expiry_date_mask').mask('99/99/9999', {reverse: true});
  $('.reporting_date_mask').mask('99/99/9999', {});
  $('.ras_number_mask').mask('CC/IJ/00/00', {
    translation: {
      'C': { pattern: /[A-Z]/ },
      'I': { pattern: /[I]/ },
      'J': { pattern: /[I]/, optional: true },
    },
    placeholder: 'CC/II/NN/NN'
  });
}

function init_wysiwyg_editor() {
  tinymce.remove();
  tinymce.init({
    selector: '#id_extra_information',
    branding: false,
    menubar: false,
    statusbar: false,
    content_css: false,
    skin: false,
    plugins: "autoresize lists link table",
    toolbar: "undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | numlist bullist | forecolor backcolor | table",
    setup: function (editor) {
      editor.on('change', function () {
        tinymce.triggerSave();
      });
    }
  });
}

function init_product_filters() {
  let product_type$ = $('#id_product_type');
  function process_product_type() {
    function show_section_by_data_attribute(dataAttrName, sectionName){
      let data_attr = product_type$.attr(dataAttrName) || '';
      let values = data_attr.split(',');
      if (values[0] == ""){
        $('.'+sectionName).hide();
      } else {
        if (values.indexOf(product_type$.val()) > -1) {
          $('.'+sectionName).show();
        } else {
          $('.'+sectionName).hide();
        }
      }
    }
    show_section_by_data_attribute('data-medicaldevice','medical_device_section');
    show_section_by_data_attribute('data-chemical-biological','product_type_section');
  }
  if(product_type$.length > 0) {
    process_product_type();
    product_type$.on('change', process_product_type);
  }

  let product_medical_device_group$ = $('#id_product_medical_device_group');
  function process_medical_device_group() {
    let data_attr = product_medical_device_group$.attr('data-medical-device-class') || '';
    let values = data_attr.split(',');
    if(values.indexOf(product_medical_device_group$.val()) > -1) {
      $('.medical_device_class').show();
    } else {
      $('.medical_device_class').hide();
    }
  }
  if(product_medical_device_group$.length > 0) {
    process_medical_device_group();
    product_medical_device_group$.on('change', process_medical_device_group);
  }
}

function init_entry_form() {
  // To prevent the form from being submitted when pressing enter, we set
  // all buttons to type="button" and switch them to type="submit" on click.
  // While this seems strange, this is the best way to handle modern browsers,
  // because they fake a click event when a submit button exists in the form.
  $('#knowx_entry button[name="action"]').on('click', function() {
    // Also, we use click() instead of submit(), to add the "action"
    // parameter to the form data.
    $(this).attr('type', 'submit');
    $(this).off('click');
    $(this).click();
  });

  if($('#knowx_entry').attr('data-locked') == 'true') {
    $('a.add-row').addClass('disabled');
    $('a.delete-row').addClass('disabled');
  }

  init_formsets();
  init_autocomplete();
  init_date_masks();
  init_wysiwyg_editor();
  init_product_filters();
  init_select2()
}

$(document).on('change keyup mouseover', '.assessment_molecular_formula', function(e) {
  $.ajax({
    url: $(this).data('service-url') + '?formula=' + e.target.value,
    error: function(xhr, ajaxOptions, thrownError) {
      $(this).attr('data-original-title', '404 not found');
    },
    success: function(data) {
      $(this).attr('data-original-title', data).tooltip({html:true});
      $(this).attr('data-original-title', data).tooltip('show');
    }
  });
});

$(document).on('keyup', '.assessment_molecular_formula', function(e) {
  const $mass = $(this).parents('.row').find('.assessment_molar_mass');

  $.ajax({
    url: $mass.data('service-url') + '?formula=' + e.target.value,
    error: function(xhr, ajaxOptions, thrownError) {
      $(this).attr('data-original-title', '404 not found');
    },
    success: function(data) {
      if(data.mass) {
        $mass.val(data.mass);
      }
    }
  });
  if(!$(this).val()) {
    $mass.val('');
  }
});

$(document).on('keyup', '.assessment_monoistopic_mass,.assessment_ms,.number-mask', function() {
  this.value = check_strength_unit(this.value);
});

$(document).on('click', '.ajax-submit', e => {
  e.preventDefault();

  let $form = $('#knowx_entry');
  $('#loading').addClass('loading');
  $.ajax({
    type: "POST",
    url: window.location,
    data: $form.serialize(),
    success: data => {
      $form.replaceWith(data);
      init_entry_form();

      $('#top-menu-new-entry').removeClass('active');
      $('#top-menu-browse').addClass('active');

      let errors$ = $('.alert.alert-danger');
      if (errors$.length === 0) {
        let url_mask = $('#knowx_entry').attr('action');
        history.replaceState({}, "", url_mask);
        $.notify("Your entry has been saved successfully.", {
          offset: 50,
          type: 'success',
          allow_dismiss: false,
          delay: 2
        });
      } else {
        $.notify(errors$.text(), {
          offset: 50,
          type: 'danger',
          allow_dismiss: false,
          delay: 2
        });
      }
    },
    error: (jqXHR, textStatus) => {
      $.notify("Error:" + textStatus, {
        offset: 50,
        type: 'danger',
        allow_dismiss: false,
        delay: 2
      });
    },
    complete: () => {
      $('#loading').removeClass('loading');
    }
  });
});

$(document).on('change', '#id_reporting_contact', function(e) {
  const contact_url = $(this).attr('data-service-url');
  const name = e.target.value;
  const names = name.split(/\s+/).join('_');

  if(name == ''){
    $('#id_reporting_phone').attr('value', '');
    $('#id_reporting_email').attr('value', '');
  } else {
    $.ajax({
      url: contact_url.replace('name', names)
    }).done(data => {
      $('#id_reporting_phone').attr('value', data.phone);
      $('#id_reporting_email').attr('value', data.email);
    });
  }
});

$(document).ready(() => init_entry_form());
